import {
    ArrayTemplate,
    datedExcelFileName,
    downloadWorkbook,
    exportExcelFromWorkBook,
    RequiredField,
    WorkBookTemplate
} from "../../common/upload/excel.utils";
import {AlertEntity} from "../../handlers/issues-standalone-handler";
import {sendQuery} from "../../common/app-common-utils";
import {RefdataUtils} from "../refdata/refdata-utils";
import {startCase, toLower} from "lodash";
import moment from "moment";
import {TranslateDirective} from '../../common/utils/translate.directive';

export function downloadAlertsAsExcel(alerts: AlertEntity[]) {
    sendQuery("getConnectionsAsEntities").subscribe(result => {
        const data = prepareData(alerts, result);
        return exportExcelFromWorkBook(downloadWorkbook("/assets/templates/alerts-template.xlsx"),
            alertsTemplate, data, datedExcelFileName(
                TranslateDirective.getTranslation('alerts list', true) as string));
    });
}

function prepareData(alerts: AlertEntity[], refdata: any[]) {
    return {
        alerts: alerts.map(a => {
            const entityIds = a.alert.details?.entityIds || [];
            const connection = refdata.find(c => c.connection.connectionId === entityIds[1]);
            return {
                organisation: connection?.organisation.info.name,
                location: RefdataUtils.addressFormatter(connection?.location.info.address),
                ean: connection?.connection.info.code,
                alertId: a.alert.alertId,
                meterId: entityIds[0],
                type: startCase(a.alert.details.type),
                timestamp: formatTimestamp(a.alert.timestamp),
                status: a.alert.alertStatus,
                connectionType: a.alert.connectionType,
                surveyor: a.alert.surveyor,
                meterType: startCase(toLower(a.alert.meterType?.replace(/_/g, ' '))),
                message: a.alert.details.message,
                user: a.alert.assigneeId,
                note: a.alert.note,
            };
        })
    }
}

const alertInfoTemplate = {
    organisation: new RequiredField('A$'),
    location: new RequiredField('B$'),
    ean: new RequiredField('C$'),
    alertId: new RequiredField('D$'),
    meterId: new RequiredField('E$'),
    type: new RequiredField('F$'),
    timestamp: new RequiredField('G$'),
    status: new RequiredField('H$'),
    connectionType: new RequiredField('I$'),
    surveyor: new RequiredField('J$'),
    meterType: new RequiredField('K$'),
    message: 'L$',
    user: 'M$',
    note: 'N$'
};


const alertsTemplate: WorkBookTemplate = {
    sheets: [
        {
            name: 'Alerts',
            template: {
                alerts: new ArrayTemplate(alertInfoTemplate, [2, 20000])
            }
        }
    ]
}

function formatTimestamp(isoString: string): string {
    return isoString ? moment(isoString).format("DD-MM-YYYY HH:mm:ss") : '';
}
